import { memo, type ReactElement } from 'react'

function PaperPlaneIcon (): ReactElement {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512">
      <path fill="#FFF" stroke="#FFF" d="M83.4 226.6L304 256 83.4 285.4 0 480H64L512 256 64 32H0L83.4 226.6z" />
    </svg>
  )
}

export default memo(PaperPlaneIcon)
